import React from "react"
import Image from "next/image"

import LoadingSVG from "@/assets/loading.svg"

export default function Preloader() {
    //return <h1 className="mt-90">Chargement !!!</h1>

    return (
        <div className="preloader js-preloader">
            <div className="preloader__wrap">
                <div className="preloader__icon">
                    <Image src={LoadingSVG} alt="Loading" />                    
                </div>
            </div>
        </div>
    )
}